import {isExists, isEmptyObject} from "@/helpers/check_variable_types";
import moment from 'moment';

export default {
    data(){
        return {
            URLParams: {}
        }
    },
    created()
    {
        let urlParams = this.$route.query;

        for(let field in urlParams)
        {
            if (isExists(urlParams[field]))
            {
                this.URLParams[field] = JSON.parse(urlParams[field]);
            }
        }

        if (this.URLParams)
        {
            for (let item in this.URLParams)
            {
                switch (item){
                    case 'reportColumns':
                        if (!isEmptyObject(this.URLParams[item]))
                        {
                            this.setColumnsInVuex(this.URLParams[item]);
                        }
                        break;

                    case 'filters':
                        if (!isEmptyObject(this.URLParams[item]))
                        {
                            let filters = this.URLParams[item];

                            if (filters.dateRange)
                            {
                                filters.dateRange.startDate = moment(filters.dateRange.startDate);
                                filters.dateRange.endDate = moment(filters.dateRange.endDate);

                                if (filters.dateRange.startDateB)
                                {
                                    filters.dateRange.startDateB = moment(filters.dateRange.startDateB);
                                }

                                if (filters.dateRange.endDateB)
                                {
                                    filters.dateRange.endDateB = moment(filters.dateRange.endDateB);
                                }
                            }

                            this.$store.dispatch(this.namespace + '/setFilters', filters);
                        }
                        break;

                    case 'advancedFilters':
                        if (!isEmptyObject(this.URLParams[item]))
                        {
                            this.$store.dispatch(this.namespace + '/setAdvancedFilters', this.URLParams[item]);
                        }
                        break;
                }
            }
        }
    },
    mounted(){
        let that = this;

        this.$store.watch(() => this.$store.getters[this.namespace + '/getFilters'], function(filters){
            that.updateParamsInURL(filters);
        });
    },
    methods: {
        updateParamsInURL(filters){
            let result = null;
            let preparedURLParams = {};
            let data = Object.assign({}, this.URLParams, filters);

            for (let field in data)
            {
                if (field === 'reportColumns')
                {
                    result = this.prepareColumnDataForURL(data[field]);
                }
                else
                {
                    result = data[field];
                }

                if (isExists(result))
                {
                    preparedURLParams[field] = JSON.stringify(result);
                }
            }

            this.$router.replace({path: '/' + this.namespace, query : preparedURLParams});
        },
        checkParameterURLExists(paramName) {
            let params = this.$route.query;

            if (params[paramName] !== undefined && params[paramName] !== null && params[paramName].length > 0)
            {
                return true;
            }

            return false;
        },
        removeParamFromUrl: function(paramName){
            let params = Object.assign({}, this.$route.query);
            let path = this.$route.path;

            if (params !== undefined && params !== null && params[paramName] !== undefined)
            {
                delete(params[paramName]);
            }

            this.$router.replace({path: path, query: params});
        },
        prepareColumnDataForURL: function(columns){
            let preparedColumns = [];

            if (columns.length)
            {
                for (let column of columns)
                {
                    preparedColumns.push({
                        field: column.field,
                        checked: column.checked,
                        visible: column.visible,
                        fixed: column.fixed
                    })
                }
            }

            return preparedColumns;
        },
        setColumnsInVuex: function(columns){
            let preparedColumns = [];

            for(let column of columns)
            {
                let foundItems = this.defaultColumns.filter(item => item.field == column.field);
                let foundItem = foundItems[0];

                if (foundItems.length)
                {
                    let updatedItem = Object.assign(foundItem, column);
                    preparedColumns.push(updatedItem);
                }
            }

            if (preparedColumns.length)
            {
                this.columns = preparedColumns;
                this.$store.dispatch(this.namespace + '/setReportColumns', preparedColumns);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/URLSyncMixin.js